import React from 'react';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import { lazyPage } from '../lazyPage';

const RolesPage = lazyPage(() => import(/* webpackChunkName: "m-platform-admin" */ './pages/RolesPage'));

/**
 * RBAC admin console (USER_LEAD_LIFECYCLE §8-A) — Platform Admin module.
 *
 * Gated by the existing `role_mgmt` feature (same as the legacy Role Management,
 * which stays reachable at /role-management during cutover — strangler). This is
 * the canonical "roles are data" editor built to the consolidated §8-A contract.
 */
const rbacManifest = {
    id: 'rbac-roles',
    featureName: 'role_mgmt',
    permission: 'view',
    routes: [{ path: '/roles', element: <RolesPage /> }],
    sidebarItems: [{ text: 'Roles & Access', icon: <AdminPanelSettingsOutlinedIcon />, link: '/roles' }],
};

export default rbacManifest;
